module.exports = __webpack_public_path__ + "static/media/IMG_1295.df3312e1.jpg";